export default __webpack_public_path__ + "book_details-reading_age.961365a1.png";